
// 多选时间 

<template>
  <div>
    <span class="label__box">{{ label }}</span>
    <el-date-picker
      v-model="currentValue"
      :value-format="valueFormat[dateType]"
      :type="dateType"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      class="ipt__box"
      placeholder="选择日期时间"
      :default-time="['00:00:00', '23:59:59']"
      @change="onChange"
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String
    },
    keys: {
      type: Array
    },
    values: {
      type: Array
    },
    dateType: {
      type: String
    }
  },
  data () {
    return {
      currentValue: [],
      valueFormat: {
        'daterange': 'yyyy-MM-dd',
        'datetimerange': 'yyyy-MM-dd HH:mm:ss',
        'monthrange': 'yyyy-MM',
      }
    }
  },
  watch: {
    values: {
      handler(v) {
        // console.log('date', v, v[0])
        if (v[0]) {
          this.currentValue = v
        } else {
          this.currentValue = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onClear () {
      let date = ['', '']
      let result = {}
      date.forEach((element, index) => {
        result[this.keys[index]] = element
      });
      this.$emit('onChange', result)
    },
    onChange (value) {
      if (value) {
        let result = {}
        
        value.forEach((element, index) => {
          result[this.keys[index]] = element
        });
        this.$emit('onChange', result)
      } else {
        this.onClear()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.label__box {
  display: inline-block;
  font-size: 14px;
  width: 80px;
}
.date {
  width: 100%;
}
.ipt__box {
  width: 360px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/items/date.vue